import { TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useState } from "react";

export const CustomQuickFilter: React.FC = () => {
  const apiRef = useGridApiContext();
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);

    // Applica il filtro alla griglia
    apiRef.current.setQuickFilterValues(value ? [value] : []);
  };

  return (
    <TextField
      size="small"
      placeholder="Search..."
      value={searchValue}
      onChange={handleSearchChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search fontSize="small" />
          </InputAdornment>
        ),
      }}
      sx={{
        minWidth: 200,
        "& .MuiOutlinedInput-root": {
          height: "32px", // Allinea l'altezza con gli altri pulsanti della toolbar
        },
      }}
    />
  );
};
